export const useResearchPagination = (
  setResearchData,
  getResearchList,
) => {
  const sort = async (sortBy, sortOrder) => {
    setResearchData((prev) => ({ ...prev, sortBy, sortOrder }));
    return getResearchList({ sortBy, sortOrder });
  };

  const paginate = async (page, payload = null) => {
    await getResearchList(payload ? { ...payload, page } : { page });
  };

  const itemsPerPage = async (perPage) => {
    await getResearchList({ perPage, page: 1 });
  };

  return {
    sort,
    paginate,
    itemsPerPage,
  };
};
